import React from 'react';
import rcc from 'create-react-class';
import pt from 'prop-types';

import { ProgressBar } from 'react-bootstrap';

// presentational component for uploads
// inline button and progresss bar
var UploadView = rcc({
    propTypes: {
        progress: pt.number,
        isUploading: pt.bool,
        fileName: pt.string,
        onUploadStart: pt.func.isRequired
    },

    onFileChange: function (ev) {
        this.props.onUploadStart(this.refs.formEl.elements.media.files[0]);
    },

    chooseFile: function (ev) {
        ev.preventDefault();
        this.refs.inputEl.click();
    },

    render: function () {
        return (<form className="inv-upload-view" ref="formEl">
            <div className="input-group">

                <span className="input-group-btn">
                    <button type="submit"
                        className="btn btn-primary"
                        onClick={this.chooseFile}
                        disabled={this.props.isUploading}
                    >
                        Upload new file
                    </button>
                </span>

                <input
                    id="fileNamePreview"
                    className="form-control"
                    value={this.props.fileName}
                    readOnly
                />

            </div>

            {this.props.isUploading ?
                <ProgressBar now={this.props.progress} /> :
                null
            }

            <input
                onChange={this.onFileChange}
                ref="inputEl"
                type="file"
                className="hidden"
                name="media"
            />
        </form>);
    }
});


export default UploadView;
